import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=f544993c&scoped=true&"
import script from "./RichTextEditor.vue?vue&type=script&lang=js&"
export * from "./RichTextEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f544993c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
